
import React, { useState, useEffect } from "react";
import "./ReferalList.scss";
import referalListIcon from "../../../../utilities/images/refer&earn/referalListIcon.png";
import calender from "../../../../utilities/images/refer&earn/calender.png";
import RewardCoinImage from "../../../../utilities/images/refer&earn/rewardCoin.png";
import DateModalRange from "./dateModalRange/DateModalRange";
import axios from "axios";
import { url_185 } from "../../../../custom_utilities/api_services";

const ReferalList = ({ tokenType, token }) => {
  const [state, setState] = useState({
    referalList: [],
    open: false,
  });

  const [range, setRange] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection",
    },
  ]
  );

  useEffect(() => {
    getReferalLists();
  }, [range[0].startDate, range[0].endDate]);

  const handleCloseModal = () => {
    setState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const getReferalLists = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    const data = {
      start_date : range[0].startDate,
      end_date : range[0].endDate,
    };

    try {
      const response = await axios.post(url_185, data, { headers });

      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          referalList: response.data.referral_list,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowModal = () => {
    setState((prevState) => ({
      ...prevState,
      open: true,
    }));
  };

 

  return (
    <div className="referalListwrppr">
      <div className="referalListTitle">
        <div className="left">
          <img src={referalListIcon} alt="referalListIcon" />
          <div className="text">Referral List</div>
        </div>
        <div className="right">
          <img
            src={calender}
            onClick={handleShowModal}
            style={{ cursor: "pointer" }}
            alt="calenderIcon"
          />
        </div>
      </div>

      <div className="lists">
        {state.referalList &&
          state.referalList.map((item) => {
            return (
              <div className="list">
                <div className="left">
                  <div className="referalIdAndName">{item.name}</div>
                  <div className="date">
                    Date : <span>{item.date}</span>
                  </div>
                </div>
                <div className="right">
                  <div className="referalCoins">
                    <text> + {item.coins} </text>
                    <span>
                      <img src={RewardCoinImage} alt="RewardCoinImage" />
                    </span>
                  </div>
                  <div className="text">Earned</div>
                </div>
              </div>
            );
          })}
      </div>

      <DateModalRange
        open={state.open}
        onClose={handleCloseModal}
        range={range}
        setRange={setRange}
       
      />
    </div>
  );
};

export default ReferalList;
